<template>
  <div class="overlay" @keydown.esc="$emit('click')" ref='focusMe' tabindex="0">
    <x-icon size="2x" class="model-close" @click="$emit('click')"></x-icon>
      <iframe :width="fit.width" :height="fit.height" :src="link"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen class="video-frame" style="border:none;overflow:hidden" allowTransparency="true"
      ></iframe>
  </div>
</template>

<script>
import { XIcon } from 'vue-feather-icons'

export default {
  name: "VideoModal",
  props: {
    link: String, size: Object
  },
  components: {
    'x-icon': XIcon
  },
  mounted () {
    this.$refs.focusMe.focus()
  },
  data: function () {
    return {
      percentage: 0.7
    }
  },
  computed: {
    fit: function () {
      const R = window.innerHeight / window.innerWidth;
      const r = this.size.height / this.size.width;

      if (R > r) {
        return {
          height: r * Math.min(this.size.width, window.innerWidth * this.percentage),
          width: Math.min(this.size.width, window.innerWidth * this.percentage)
        }
      } else {
        return {
          height: Math.min(this.size.height, window.innerHeight * this.percentage),
          width: Math.min(this.size.height, window.innerHeight * this.percentage) / r
        }
      }
    }
  }
}
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.9);
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.overlay:focus {
  outline: none;
}
.model-close {
  color: white;
  position: absolute;
  top: 30px;
  right: 30px;
}
.model-close:hover {
  color: grey;
}
.model-close:active {
  color: white;
}
.video-frame {
  border: 0;
  margin: 0 auto;
  /*width: 800px;*/
  /*height: 450px;*/
}
</style>